export default __webpack_public_path__ + "static/01_cover-1c904e107eceb4416619cfcf2663829a.jpg";